import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinimize315: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMinimize315"><Path fillRule="evenodd" clipRule="evenodd" d="M2.68896 3.75011L8.43896 9.50011H2.99962V11.0001H10.9996V3.00011H9.49962V8.43945L3.74962 2.68945L2.68896 3.75011ZM20.9996 13.0001H12.9996V21.0001H14.4996V15.5608L20.2496 21.3108L21.3103 20.2501L15.5603 14.5001H20.9996V13.0001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinimize315;
